import React, { Fragment, useState } from "react";
import { Card, CardBody, Col, CardFooter, Row } from "reactstrap";
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from "Layout/AppMain/PageHeading";
import 'react-datepicker/dist/react-datepicker.css';
import 'tippy.js/dist/tippy.css';
import moment from 'moment';
import Loader from 'react-loaders';
import ReactTableGeneric from 'Components/ReactTableGeneric';
import { useAuthorizationLogs } from 'Api/Common/LogboekLogin';
import { DropdownList } from "react-widgets/cjs";
import { useCommunityContractList } from "Api/Common/LogPersoonsgegevens";

const LogboekAuthorisatie = () => {
    const [selectedCommunity, setSelectedCommunity] = useState("");
    const {
        data: authorizationResponse,
        isLoading,
    } = useAuthorizationLogs(selectedCommunity);

    const logs = authorizationResponse?.data || [];
     const totalCount = authorizationResponse?.total || [];

    const {
        data: communityResponse,
        isLoading: communityLoading,
    } = useCommunityContractList();

    const communities = [
        {
            iCommunityId: "all",
            vCommunityName: "Alle besturen",
        },
        ...(communityResponse?.communities || []),
    ];


    const columns = [
        {
            header: 'Datum-tijd',
            accessorKey: 'created_at',
            cell: ({ row }) =>
                moment(row.original.created_at).format(
                    'DD-MM-YYYY HH:mm:ss'
                ),
        },
        {
            header: 'Organisatie',
            accessorKey: 'vCommunityName',
        },
        {
            header: 'Naam uitvoerder - Clooser ID',
            accessorKey: 'performed_naam_clooser_id',
        },
        {
            header: 'Rol',
            accessorKey: 'vRole',
            cell: ({ getValue }) => {
                const value = getValue();

                if (Array.isArray(value)) {
                    return value.join(' / ');
                }

                return value || '-';
            }
        },
        {
            header: 'Actie',
            accessorKey: 'eAction',
        },
        {
            header: 'Naam betrokkene - Clooser ID',
            accessorKey: 'affected_naam_clooser_id',
        },
    ];

    if (isLoading) {
        return (
            <Loader
                type="ball-grid-pulse"
                className="mt-3 d-flex mx-auto justify-content-center"
            />
        );
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Row>
                    <Col md="12">
                        <Card className="main-card mb-3">
                            <CardBody className="p-3">
                                <ReactTableGeneric
                                    data={logs}
                                    columns={columns}
                                    filters={{
                                        search: true,
                                        pagination: true,
                                        sorting: true,
                                    }}
                                    tableClassName="mb-0 table table-sm table-hover table-borderless color-white"
                                    count={totalCount}
                                />
                            </CardBody>

                        </Card>
                    </Col>
                </Row>
            </TransitionOnLoad>
            <div className="chat-layout-footer">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                    <div className="d-flex gap-3 mr-4">
                        <div className="footer-field-min-width">
                            <DropdownList
                                data={communities}
                                dataKey="iCommunityId"
                                textField="vCommunityName"
                                placeholder="Organisatie"
                                value={
                                    communities.find(
                                        c => c.vCommunityName === selectedCommunity
                                    ) || communities[0]
                                }


                                onChange={(community) =>
                                    setSelectedCommunity(community?.vCommunityName?? "")
                                }
                                filter="contains"
                                dropUp
                            />
                        </div>
                    </div>
                </CardFooter>
            </div>
        </Fragment>
    );
};

export default LogboekAuthorisatie;